import { HttpClient, RequestConfig } from "@planzone/services";

function getTimeZone() {
  return new Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function createTimeZoneProvider(httpClient: HttpClient): HttpClient {
  return {
    sendHttpRequest<Response>(config: RequestConfig): Promise<Response> {
      return httpClient.sendHttpRequest({
        ...config,
        headers: {
          timezone: getTimeZone(),
          ...config.headers,
        },
      });
    },
  };
}

export { createTimeZoneProvider };
